import React from "react";
import Seo from "../components/seo/Seo";
import Container from "../components/ui/Container";
import Hero from "../components/sections/Hero";
import CoreServices from "../components/sections/CoreServices";
import Stats from "../components/sections/Stats";
import WhyChooseUs from "../components/sections/WhyChooseUs";
import Industries from "../components/sections/Industries";
import ServicesTeaser from "../components/sections/ServicesTeaser";
import Countries from "../components/sections/Countries";
import Partners from "../components/sections/Partners";
import Testimonials from "../components/sections/Testimonials";
import QuoteCta from "../components/sections/QuoteCta";

const Home = () => (
  <>
    <Seo
      title="Freight, Warehousing & Machinery in East Africa"
      description="Cargo Power Logistics delivers reliable road, air, and ocean freight, warehousing, and machinery services across Kenya, Uganda, Tanzania, Rwanda, Congo, and Burundi. Request a quote today."
    />
    <Hero />
    <CoreServices />
    <Stats />

    {/* Why Choose Us + Industries split */}
    <section className="bg-surface py-20 md:py-section-gap">
      <Container>
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-2 lg:gap-section-gap">
          <WhyChooseUs />
          <Industries />
        </div>
      </Container>
    </section>

    <ServicesTeaser />
    <Countries />
    <Partners />
    <Testimonials />
    <QuoteCta />
  </>
);

export default Home;
